/* eslint-disable header/header */ export const Web3PkgInfo = { version: '1.0.1' };
